module.exports = __webpack_public_path__ + "static/media/aayush.e45b3b5c.png";